"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ParameterValidateFailed"] = 10001] = "ParameterValidateFailed";
    ErrorCode[ErrorCode["LocationTooFar"] = 10002] = "LocationTooFar";
    ErrorCode[ErrorCode["UnableToContactTenant"] = 10003] = "UnableToContactTenant";
    ErrorCode[ErrorCode["ConsumerRequestNotFound"] = 10004] = "ConsumerRequestNotFound";
    ErrorCode[ErrorCode["ConsumerRequestCanNotBeChanged"] = 10005] = "ConsumerRequestCanNotBeChanged";
    ErrorCode[ErrorCode["ConsumerRequestNoLongerPending"] = 10006] = "ConsumerRequestNoLongerPending";
    ErrorCode[ErrorCode["CouldNotCancelConsumerRequest"] = 10007] = "CouldNotCancelConsumerRequest";
    ErrorCode[ErrorCode["FailedToCancelConsumerRequestRelatedProviderRequest"] = 10008] = "FailedToCancelConsumerRequestRelatedProviderRequest";
    ErrorCode[ErrorCode["SmartHomeServiceRouting"] = 10009] = "SmartHomeServiceRouting";
    ErrorCode[ErrorCode["ProviderRequestNotFound"] = 10009] = "ProviderRequestNotFound";
    ErrorCode[ErrorCode["ProviderNotCompliant"] = 10010] = "ProviderNotCompliant";
    ErrorCode[ErrorCode["ProviderRequestNoLongerPending"] = 10010] = "ProviderRequestNoLongerPending";
    ErrorCode[ErrorCode["ProviderRequestNoLongerAccepted"] = 10011] = "ProviderRequestNoLongerAccepted";
    ErrorCode[ErrorCode["ProviderRequestAlreadyRejected"] = 10012] = "ProviderRequestAlreadyRejected";
    ErrorCode[ErrorCode["FailedToRejectProviderRequest"] = 10013] = "FailedToRejectProviderRequest";
    ErrorCode[ErrorCode["JobCanNotBeChanged"] = 10014] = "JobCanNotBeChanged";
    ErrorCode[ErrorCode["JobLockedUntilPropertyManagerUnlock"] = 10015] = "JobLockedUntilPropertyManagerUnlock";
    ErrorCode[ErrorCode["LocationLeadRisk"] = 10016] = "LocationLeadRisk";
    ErrorCode[ErrorCode["NoCreditCardOnFile"] = 30001] = "NoCreditCardOnFile";
    ErrorCode[ErrorCode["PaymentVerificationFailed"] = 30002] = "PaymentVerificationFailed";
    ErrorCode[ErrorCode["ProcessChargeFailed"] = 30003] = "ProcessChargeFailed";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
